 /*
  OyeGifts Lightweight Premium Badge
  File: assets/og-product-badges.js

  - 25% products par badge
  - Same product = same badge on collection and product page
  - Collection: strong white shine
  - Product page: strong white shine + shake every 3 seconds
  - Desktop and mobile
  - Badge only; price/rating/review untouched
*/

(function () {
  "use strict";

  var SHOW_PERCENT = 35;
  var STYLE_ID = "og-product-badge-style";
  var BADGE_CLASS = "og-product-badge";
  var HOST_CLASS = "og-product-badge-host";

  var BADGES = [
    ["⚡", "NEW ARRIVAL", "#087443"],
    ["🎯", "RECOMMENDED", "#b54708"],
    ["💎", "EXCLUSIVE", "#173f52"],
    ["♡", "MOST LOVED", "#a91f46"],
    ["🔥", "BESTSELLER", "#971f1f"],
    ["◆", "PREMIUM", "#1d2939"]
  ];

  function isProductPage() {
    return location.pathname.indexOf("/products/") === 0;
  }

  function isListingPage() {
    return (
      location.pathname === "/" ||
      location.pathname.indexOf("/collections/") === 0 ||
      location.pathname.indexOf("/search") === 0
    );
  }

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement("style");
    style.id = STYLE_ID;

    style.textContent = `
      .${HOST_CLASS}{
        position:relative!important;
        overflow:hidden!important;
        isolation:isolate!important;
      }

      .${BADGE_CLASS}{
        position:absolute!important;
        top:0!important;
        right:0!important;
        z-index:30!important;
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        gap:6px!important;
        min-height:30px!important;
        max-width:calc(100% - 4px)!important;
        padding:7px 12px!important;
        border:1px solid rgba(255,255,255,.24)!important;
        border-radius:0 0 0 12px!important;
        color:#fff!important;
        box-shadow:0 5px 14px rgba(0,0,0,.24)!important;
        font-family:inherit!important;
        font-size:12px!important;
        font-weight:600!important;
        line-height:1!important;
        letter-spacing:.25px!important;
        text-transform:uppercase!important;
        white-space:nowrap!important;
        pointer-events:none!important;
        overflow:hidden!important;
        will-change:transform!important;
      }

      .${BADGE_CLASS}__icon,
      .${BADGE_CLASS}__text{
        position:relative!important;
        z-index:3!important;
      }

      .${BADGE_CLASS}__icon{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        font-size:11px!important;
        line-height:1!important;
      }

      .${BADGE_CLASS}::before{
        content:""!important;
        position:absolute!important;
        top:-80%!important;
        left:-110%!important;
        z-index:2!important;
        width:44%!important;
        height:280%!important;
        background:linear-gradient(
          90deg,
          rgba(255,255,255,0) 0%,
          rgba(255,255,255,.18) 24%,
          rgba(255,255,255,1) 50%,
          rgba(255,255,255,.18) 76%,
          rgba(255,255,255,0) 100%
        )!important;
        transform:skewX(-24deg)!important;
        animation:ogBadgeShine 2s linear infinite!important;
      }

      @keyframes ogBadgeShine{
        0%{left:-110%;opacity:0}
        8%{opacity:1}
        48%{left:140%;opacity:1}
        58%,100%{left:140%;opacity:0}
      }

      .${BADGE_CLASS}.is-product{
        animation:ogBadgeShake 3s ease-in-out infinite;
      }

      @keyframes ogBadgeShake{
        0%,72%,100%{transform:translateX(0)}
        76%{transform:translateX(-7px)}
        80%{transform:translateX(7px)}
        84%{transform:translateX(-5px)}
        88%{transform:translateX(5px)}
        92%{transform:translateX(-2px)}
        96%{transform:translateX(2px)}
      }

      @media(max-width:749px){
        .${BADGE_CLASS}{
          min-height:25px!important;
          padding:6px 9px!important;
          gap:4px!important;
          border-radius:0 0 0 10px!important;
          font-size:9.5px!important;
          letter-spacing:.14px!important;
        }

        .${BADGE_CLASS}__icon{
          font-size:9px!important;
        }

        .${BADGE_CLASS}.is-product{
          animation-name:ogBadgeShakeMobile;
        }
      }

      @keyframes ogBadgeShakeMobile{
        0%,72%,100%{transform:translateX(0)}
        76%{transform:translateX(-5px)}
        80%{transform:translateX(5px)}
        84%{transform:translateX(-3px)}
        88%{transform:translateX(3px)}
        94%{transform:translateX(0)}
      }
    `;

    document.head.appendChild(style);
  }

  function hash(value) {
    var str = String(value || "").toLowerCase();
    var h = 2166136261;

    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h +=
        (h << 1) +
        (h << 4) +
        (h << 7) +
        (h << 8) +
        (h << 24);
    }

    return h >>> 0;
  }

  function getHandle(url) {
    var match = String(url || "").match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function shouldShow(handle) {
    return hash(handle + ":show") % 100 < SHOW_PERCENT;
  }

  function getBadgeData(handle) {
    return BADGES[hash(handle + ":badge") % BADGES.length];
  }

  function getCard(link) {
    return (
      link.closest(".grid__item") ||
      link.closest(".product-card-wrapper") ||
      link.closest(".card-wrapper") ||
      link.closest(".product-card") ||
      link.closest(".product-item") ||
      link.closest("li") ||
      link.parentElement
    );
  }

  function getCardImage(card) {
    return (
      card.querySelector(".card__inner") ||
      card.querySelector(".card__media") ||
      card.querySelector(".media") ||
      card.querySelector(".product-card__image-wrapper") ||
      card.querySelector(".product-item__image-wrapper") ||
      card.querySelector(".product-image") ||
      card.querySelector("a[href*='/products/']")
    );
  }

  function getProductImage() {
    var selectors = [
      ".product__media-item.is-active .product__media",
      ".product__media-item:first-child .product__media",
      ".product__media-wrapper .product__media",
      ".product__media-wrapper .media",
      ".product-media-container",
      ".product-gallery .media",
      ".product-single__media",
      ".product__media-wrapper img",
      ".product img"
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (!el) continue;

      if (el.tagName && el.tagName.toLowerCase() === "img") {
        return el.parentElement;
      }

      if (el.querySelector && el.querySelector("img")) {
        return el;
      }
    }

    return null;
  }

  function createBadge(handle, productPage) {
    var data = getBadgeData(handle);
    var badge = document.createElement("div");

    badge.className = BADGE_CLASS + (productPage ? " is-product" : "");
    badge.style.backgroundColor = data[2];

    badge.innerHTML =
      '<span class="' + BADGE_CLASS + '__icon">' + data[0] + '</span>' +
      '<span class="' + BADGE_CLASS + '__text">' + data[1] + "</span>";

    return badge;
  }

  function placeBadge(host, handle, productPage) {
    if (!host || !handle) return;

    var old = host.querySelector("." + BADGE_CLASS);
    if (old) old.remove();

    if (!shouldShow(handle)) return;

    if (host.tagName && host.tagName.toLowerCase() === "img") {
      host = host.parentElement;
    }

    host.classList.add(HOST_CLASS);
    host.insertBefore(createBadge(handle, productPage), host.firstChild);
  }

  function renderCollection() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    var used = [];

    links.forEach(function (link) {
      if (link.closest("header,nav,footer,.cart,.drawer,.cart-drawer")) return;

      var handle = getHandle(link.getAttribute("href"));
      var card = getCard(link);

      if (!handle || !card || used.indexOf(card) !== -1) return;
      used.push(card);

      placeBadge(getCardImage(card), handle, false);
    });
  }

  function renderProduct() {
    var handle = getHandle(location.pathname);
    placeBadge(getProductImage(), handle, true);
  }

  function render() {
    addStyles();

    if (isProductPage()) {
      renderProduct();
    } else if (isListingPage()) {
      renderCollection();
    }
  }

  function init() {
    render();
    setTimeout(render, 800);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.ogRefreshProductBadges = render;
})();